import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'
import { type UserRole, roleSatisfies } from '@alpha-edge/shared'

export function CentralHomePage() {
  const { user } = useAuth()
  const role = user?.role as UserRole | undefined
  if (role && roleSatisfies(role, ['medflow_admin'])) return <Navigate to="/fleet" replace />
  return <Navigate to="/licenses" replace />
}
